/* src/app/modules/ct-status/components/cts-gantry-init/cts-gantry-init.component.scss */
:host {
  display: block;
}
.details-container {
  display: flex;
  flex-flow: row nowrap;
  overflow-x: auto;
  padding-bottom: 0.5rem;
  gap: 3rem;
}
.details-container app-cts-gantry-log-table,
.details-container app-cts-gantry-startup-pane {
  flex: 1;
}
app-cts-gantry-log-table.slide-in {
  animation: slide-in 0.15s linear forwards;
}
@keyframes slide-in {
  0% {
    transform: translate(40%);
  }
  100% {
    transform: translate(0%);
  }
}
/*# sourceMappingURL=cts-gantry-init.component.css.map */
